<template>
    <v-card :loading="loading" min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-card-title>
            <v-layout row wrap>
                <v-col cols="6">
                    {{ title }}
                </v-col>
                <v-col cols="6" class="text-right">
                    <v-btn
                        v-if="hasAddNewButton"
                        color="primary"
                        dark
                        class="ml-2"
                        :href="$router.resolve({ name: 'equipment-worksheet-create' }).href"
                        @click="addNewItem"
                    >
                        Adaugare
                    </v-btn>
                </v-col>
                <v-col md="5" sm="12">
                    <period-selector v-model="period" :button-class="['mt-3']"></period-selector>
                </v-col>
                <v-col v-if="hasRole('admin')" md="4" sm="12">
                    <user-selector v-model="filterByUser"></user-selector>
                </v-col>
                <v-col md="3" sm="12" class="text-right">
                    <search-field v-model="search"></search-field>
                </v-col>
            </v-layout>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            class="elevation-1"
        >
            <template v-slot:item.offer_date="{ item }">
                {{ new Date(item.offer_date) | date }}
            </template>
            <template v-slot:item.document_no="{ item }">
                {{ item.document_number }}
            </template>
            <template v-slot:item.status="{ item }">
                {{ item.status_friendly }}
            </template>
            <template v-slot:item.customer_id="{ item }">
                {{ item.customer.name }}
            </template>
            <template v-slot:item.equipment_id="{ item }">
                {{ _.get(item, 'equipment.brand', '-') }} / {{ _.get(item, 'equipment.model', '-') }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn
                    outlined
                    x-small
                    fab
                    class="mr-2"
                    color="primary"
                    @click="downloadPDF(item)"
                >
                    <v-icon>
                        mdi-file-pdf
                    </v-icon>
                </v-btn>
                <v-btn
                    v-if="canUpdate(item)"
                    outlined
                    x-small
                    fab
                    class="mr-2"
                    color="primary"
                    :href="$router.resolve({ name: 'equipment-worksheet-edit', params: { id: item.id } }).href"
                    @click="editItem($event, item)"
                >
                    <v-icon>
                        mdi-pencil
                    </v-icon>
                </v-btn>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
    import SmartTable from "Components/SmartTable";
    import PeriodSelector from "Components/common/PeriodSelector";
    import UserSelector from "Components/common/UserSelector";
    import throttle from 'lodash/throttle'
    import ACL from "Mixins/acl";
    export default {
        mixins: [ACL],
        extends: SmartTable,
        components: {
            PeriodSelector,
            UserSelector
        },
        data: () => ({
            title: 'Fise de intrari/iesiri service',
            dialog: false,
            loading: true,
            headers: [
                { text: 'Numar', value: 'document_no' },
                { text: 'Data', value: 'offer_date' },
                { text: 'Client', value: 'customer_id' },
                { text: 'Telefon', value: 'data.phone', sortable: false },
                { text: 'E-mail', value: 'data.email', sortable: false },
                { text: 'Utilaj', value: 'equipment_id' },
                { text: 'Stare', value: 'status' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            items: [],
            options: {
                sortBy: ['created_at'],
                sortDesc: [true]
            },
            editedIndex: -1,
            editedItem: {},
            defaultItem: {},
            period: [window.moment().subtract(1, 'month').toISOString(), window.moment().toISOString()],
            filterByUser: null
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            period: {
                async handler(val) {
                    await this.initialize()
                }
            },
            filterByUser: {
                async handler(val) {
                    await this.initialize()
                }
            }
        },

        async created () {
            await this.initialize()
        },

        methods: {
            initialize: throttle(async function() {
                this.loading = true
                var query = this.$db.EquipmentWorksheet
                    .orderBy(this.orderBy)
                    .append('document_number')
                    .include('customer', 'equipment')
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                if(this.period instanceof Array && this.period.length === 2) {
                    query = query.where('between', [window.moment(this.period[0]).format('YYYY-MM-DD'), window.moment(this.period[1]).format('YYYY-MM-DD')].join(','))
                }
                if(!this._.isNil(this.filterByUser)) query = query.where('created_by', this.filterByUser.join(','))
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
                this.loading = false
            }, 1000),

            editItem (e, item) {
                e.preventDefault()
                this.$router.push({ name: 'equipment-worksheet-edit', params: { id: item.id } })
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            save () {
            },

            addNewItem: function(e) {
                e.preventDefault()
                this.$router.push({ name: 'equipment-worksheet-create' })
            },
            async downloadPDF(item) {
                const downloadEndpoint = new this.$db.EquipmentWorksheet({id: item.id}).downloadEndpoint
                this.loading = true
                await this.downloadFile(downloadEndpoint)
                await this.initialize()
                this.loading = false
            }
        },
    };
</script>
